export function setupAddonCheckboxes(): void {
  const checkboxes = document.querySelectorAll<HTMLInputElement>(
    '.addon-option input[type="checkbox"]'
  );

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const addonsField = document.querySelector<HTMLInputElement>(
        'input[name="properties[_addons]"]'
      );
      const includeSupplementInput = document.querySelector<HTMLInputElement>(
        'input[name="properties[_addonIncluded]"]'
      );

      if (!addonsField || !includeSupplementInput) return;

      addonsField.value = Array.from(checkboxes)
        .filter((cb) => cb.checked)
        .map((cb) => cb.dataset.addonId || '')
        .join(',');

      const hasChecked = Array.from(checkboxes).some((cb) => cb.checked);
      includeSupplementInput.value = hasChecked ? 'true' : 'false';
    });
  });
}
